import moment from 'moment';
import { shutdownFiltersData } from '../../constants';
import { fromDateStr, toDateStr } from '../../../../../helpers/utcDate';

const {
  filters: { period, search, house, isNew, onlyActive, fromNotification },
} = shutdownFiltersData;

const toMoment = (dateStr) => moment(dateStr);

export const createObjFromParams = (searchParams) => {
  const params = new Map();

  searchParams.forEach((value, key) => {
    if (key === period.name) {
      const [fromDate, toDate] = period.isValid(value)
        ? value.split(',').map(toMoment)
        : period.initialValue.map(toMoment);
      params.set('from', fromDateStr(fromDate));
      params.set('to', toDateStr(toDate));
    }

    if (key === search.name && search.isValid(value)) {
      params.set(search.name, Number(value));
    }

    if (key === isNew.name && isNew.isValid(value)) {
      params.set(isNew.name, Number(value));
    }

    if (key === house.name && house.isValid(value)) {
      params.set('houseId', Number(value));
    }

    if (key === onlyActive.name && onlyActive.isValid(value)) {
      params.set('onlyActive', JSON.parse(value));
    }

    if (key === fromNotification.name && fromNotification.isValid(value)) {
      params.set('fromNotification', Number(value));
    }
  });

  return { params: Object.fromEntries(params), size: params.size };
};
